import { TmrBaseResource } from 'stylewhere/api'

/**
 * Use this for encoding related production order rows.
 * For non encoding related production order rows please use ProductionOrderRows.
 */
export class EncodingProductionOrderRows extends TmrBaseResource {
  static endpoint = 'api/v1/encodingProductionOrderRows'

  static searchWithRunId<T>(params: Record<string, any> = {}, runId?: string, operationId?: string) {
    return this.search<T>(runId ? { ...params, runId, operationId } : params)
  }
}
